export { default as facebook } from './social/logo-facebook.svg'
export { default as twitter } from './social/logo-twitter.svg'
export { default as youtube } from './social/logo-youtube.svg'
export { default as facebook_light } from './social/logo-facebook-light.svg'
export { default as twitter_light } from './social/logo-twitter-light.svg'
export { default as youtube_light } from './social/logo-youtube-light.svg'
export { default as logo } from './logo.svg'
export { default as logo_light } from './logo-light.png'
export { default as logo_light_tall } from './logo-light-tall.png'
export { default as search } from './search.svg'
export { default as hamburger } from './hamburger-menu.svg'
export { default as surveyLogo } from './afpa-surveys-logo.png'
export { default as award } from './medicare-champions.png'
